import type {
  AnswerReq,
  AnswerRes,
  ExistsRes,
  QuestionsList,
} from '@/models/interface/telemarketQuestionnaire';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class TelemarketQuestionnaireService extends ApiFactory {
  constructor() {
    super('Questionnaire');
  }

  submitAnswer(params: AnswerReq): Promise<ApiDataResponse<AnswerRes>> {
    return super.post('Answer', params);
  }

  fetchQuestions(): Promise<ApiDataResponse<QuestionsList[]>> {
    return super.get('Questions');
  }

  fetchExists(): Promise<ApiDataResponse<ExistsRes>> {
    return super.get('Show');
  }
}
